import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=493ecd74&scoped=true&"
import script from "./DropArea.vue?vue&type=script&lang=js&"
export * from "./DropArea.vue?vue&type=script&lang=js&"
import style0 from "./DropArea.vue?vue&type=style&index=0&id=493ecd74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ecd74",
  null
  
)

export default component.exports